import styled from 'styled-components'

import { theme } from 'styles/theme'

const { borderWidths, colors, radii, space, zIndices } = theme

export const Card = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 18rem;
  max-width: 80vw;
  aspect-ratio: 9 / 16;
  overflow: hidden;
  border: ${borderWidths['border-stroke-micro']} solid ${`${colors['cyan-icon-hover']}80`};
  border-radius: ${radii['corner-radius-md']};
  background-color: ${colors['blue-background-strong-default']};
`

export const Placeholder = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(160deg, ${colors['blue-background-strong-default']} 0%, ${colors['cashme-dark-blue']} 100%);
`

export const PlayButton = styled.button`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: ${zIndices[2]};
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${space['spacing-xxxl']};
  height: ${space['spacing-xxxl']};
  padding: 0;
  border: 0;
  border-radius: ${radii['corner-radius-circular']};
  background-color: ${`${colors['neutral-background-contrast-medium']}80`};
  transform: translate(-50%, -50%);
  cursor: pointer;

  svg {
    width: 100%;
    height: 100%;
  }
`

export const VideoWrapper = styled.div`
  position: absolute;
  inset: 0;
  z-index: ${zIndices[2]};

  iframe,
  video {
    width: 100%;
    height: 100%;
    border: 0;
  }

  video {
    object-fit: contain;
  }
`
